module.exports = __webpack_public_path__ + "img/books-stack-of-three.ad021ae4.png";